import { Button, Stack, Text, Tile, Title } from "@assetwatch/ui";

type ProcedureLoadErrorProps = {
  appearance: "centered" | "tile";
  description: string;
  isRetrying: boolean;
  onRetry: () => void;
  title: string;
};

export function ProcedureLoadError({
  appearance,
  description,
  isRetrying,
  onRetry,
  title,
}: ProcedureLoadErrorProps) {
  const content = (
    <Stack gap={8}>
      <Title as="h2" size="lg">
        {title}
      </Title>
      <Text>{description}</Text>
      <div>
        <Button
          loading={isRetrying}
          loadingText="Retrying"
          onClick={onRetry}
          size="sm"
          variant="outline"
        >
          Retry
        </Button>
      </div>
    </Stack>
  );

  if (appearance === "tile") {
    return (
      <Tile hasBorder padding="comfortable" tone="negative">
        {content}
      </Tile>
    );
  }

  return (
    <div className="grid min-h-80 place-items-center p-(--spacing-24) text-center">
      <Stack align="center" gap={8}>
        <Title as="h2" size="lg">
          {title}
        </Title>
        <Text tone="negative">{description}</Text>
        <Button
          loading={isRetrying}
          loadingText="Retrying"
          onClick={onRetry}
          size="sm"
          variant="outline"
        >
          Retry
        </Button>
      </Stack>
    </div>
  );
}
